import { AppointmentRequestSourceFilter } from 'apps/wrapper/src/services/appointment/types/appointment-request-source-filter';
import { AppointmentRequestStatusFilter } from 'apps/wrapper/src/services/appointment/types/appointment-request-status-filter';
import { AppointmentRequestTypeFilter } from 'apps/wrapper/src/services/appointment/types/appointment-request-type-filter';
import { useCallback } from 'react';

interface FilterState {
  requestStatus: AppointmentRequestStatusFilter[];
  requestType: AppointmentRequestTypeFilter[];
  source: AppointmentRequestSourceFilter[];
}

export const useFilterLogic = (tmpFilter: FilterState | undefined, setTmpFilter: (filter: FilterState | undefined) => void) => {
  const handleStatusChange = useCallback(
    (value: string, checked: boolean) => {
      if (!tmpFilter) return;

      const status = value as AppointmentRequestStatusFilter;
      const currentStatus = tmpFilter.requestStatus || [];
      let newStatus: AppointmentRequestStatusFilter[] = [...currentStatus];

      if (checked) {
        newStatus.push(status);
      } else {
        newStatus = newStatus.filter((s) => s !== status);
      }

      setTmpFilter({ ...tmpFilter, requestStatus: newStatus });
    },
    [tmpFilter, setTmpFilter]
  );

  const handleTypeChange = useCallback(
    (value: string, checked: boolean) => {
      if (!tmpFilter) return;

      const type = value as AppointmentRequestTypeFilter;
      const currentType = tmpFilter.requestType || [];
      let newType: AppointmentRequestTypeFilter[] = [...currentType];

      if (checked) {
        newType.push(type);
      } else {
        newType = newType.filter((t) => t !== type);
      }
      setTmpFilter({ ...tmpFilter, requestType: newType });
    },
    [tmpFilter, setTmpFilter]
  );

  const handleSourceChange = useCallback(
    (value: string, checked: boolean) => {
      if (!tmpFilter) return;

      const source = value as AppointmentRequestSourceFilter;
      const currentSource = tmpFilter.source || [];
      let newSource: AppointmentRequestSourceFilter[] = [...currentSource];

      if (checked) {
        newSource.push(source);
      } else {
        newSource = newSource.filter((s) => s !== source);
      }
      setTmpFilter({ ...tmpFilter, source: newSource });
    },
    [tmpFilter, setTmpFilter]
  );

  const handleFilterChange = useCallback(
    (filterType: 'status' | 'type' | 'source', value: string, checked: boolean) => {
      switch (filterType) {
        case 'status':
          handleStatusChange(value, checked);
          break;
        case 'type':
          handleTypeChange(value, checked);
          break;
        case 'source':
          handleSourceChange(value, checked);
          break;
        default:
          console.warn(`Unknown filter type: ${filterType}`);
          break;
      }
    },
    [handleStatusChange, handleTypeChange, handleSourceChange]
  );

  const clearAllFilters = useCallback(() => {
    setTmpFilter({
      requestStatus: [],
      requestType: [],
      source: []
    });
  }, [setTmpFilter]);

  return {
    handleFilterChange,
    clearAllFilters
  };
};
